// extracted by mini-css-extract-plugin
export default {"articleViewer":"_3_0JH","chatbotArticleFull":"_1vfDk","chatbotArticlePreview":"_1BxPm"};